<template>
  <div class="my-3 flex flex-col flex-1 w-full justify-between">
    <div class="flex flex-col flex-1 justify-center">
      <div
        v-if="description"
        class="max-[1919px]:text-xs min-[1920px]:text-lg max-[1919px]:pb-2 min-[1920px]:pb-4 text-white text-center"
      >
        {{ description }}
      </div>
      <div class="max-[1919px]:px-4 min-[1920px]:px-6 flex justify-center">
        <img src="@/static/icons/check-circle-icon.png" alt="Check Icon" />
      </div>
    </div>
    <div v-if="buttonText">
      <button
        type="button"
        class="text-white font-semibold uppercase w-full bg-transparent border border-white hover:border-black hover:text-black focus:outline-hidden rounded-full max-[1919px]:text-xs min-[1920px]:text-base max-[1919px]:p-2 min-[1920px]:p-3"
        @click="$emit('buttonClick')"
      >
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script setup>
defineProps({
  isPageMini: {
    type: Boolean,
    default: false,
  },
  description: {
    type: String,
    default: null,
  },
  buttonText: {
    type: String,
    default: null,
  },
})
defineEmits(['buttonClick'])
</script>
